import { CentreInteret } from 'common/classes/CentreInteret.class';
/**
 * Permet aux utilisateurs d'écrire leur biographie. Ils peuvent
 * en avoir plusieurs sur certaines plateformes.
 */
export class MembrePresentation {
    /**
     * Constructeur de l'objet MembrePresentation
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d, _e;
        if (row) {
            this.idMembrePresentation = (_a = row.idMembrePresentation) !== null && _a !== void 0 ? _a : null;
            this.idMembre = (_b = row.idMembre) !== null && _b !== void 0 ? _b : null;
            this.presentation = (_c = row.presentation) !== null && _c !== void 0 ? _c : null;
            this.centreInteret = row.centreInteret
                ? row.centreInteret.map((centreInteret) => new CentreInteret(centreInteret))
                : [];
            this.actif = (_d = row.actif) !== null && _d !== void 0 ? _d : 0;
            this.dateEnregistrement = (_e = row.dateEnregistrement) !== null && _e !== void 0 ? _e : null;
        }
    }
    /**
     * Récupération d'une présentation en BDD
     * @return MembrePresentation
     */
    static find( /* id: number */) {
        // TODO
    }
    /**
     * Sauvegarde en BDD
     * @return void
     */
    save() {
        // TODO
    }
    /**
     * Retire l'objet de l'affichage en mettant son statut actif à 2.
     * @return void
     */
    delete() {
        // TODO
    }
    /**
     * Utilisée pour renvoyer les informations au front.
     */
    toRaw() {
        return {
            idMembre: this.idMembre,
            presentation: this.presentation,
            centreInteret: this.centreInteret.map((centreIntret) => centreIntret.toRaw()),
            actif: this.actif,
            dateEnregistrement: this.dateEnregistrement,
            idMembrePresentation: this.idMembrePresentation,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlUHJlc2VudGF0aW9uLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTWVtYnJlUHJlc2VudGF0aW9uLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxvQ0FBb0MsQ0FBQztBQUluRTs7O0dBR0c7QUFDSCxNQUFNLE9BQU8sa0JBQWtCO0lBK0I5Qjs7O09BR0c7SUFDSCxZQUFtQixHQUFpQzs7UUFDbkQsSUFBSSxHQUFHLEVBQUU7WUFDUixJQUFJLENBQUMsb0JBQW9CLEdBQUcsTUFBQSxHQUFHLENBQUMsb0JBQW9CLG1DQUFJLElBQUksQ0FBQztZQUM3RCxJQUFJLENBQUMsUUFBUSxHQUFHLE1BQUEsR0FBRyxDQUFDLFFBQVEsbUNBQUksSUFBSSxDQUFDO1lBQ3JDLElBQUksQ0FBQyxZQUFZLEdBQUcsTUFBQSxHQUFHLENBQUMsWUFBWSxtQ0FBSSxJQUFJLENBQUM7WUFDN0MsSUFBSSxDQUFDLGFBQWEsR0FBRyxHQUFHLENBQUMsYUFBYTtnQkFDckMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUMsYUFBYSxFQUFFLEVBQUUsQ0FBQyxJQUFJLGFBQWEsQ0FBQyxhQUFhLENBQUMsQ0FBQztnQkFDNUUsQ0FBQyxDQUFDLEVBQUUsQ0FBQztZQUNOLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBQSxHQUFHLENBQUMsS0FBSyxtQ0FBSSxDQUFDLENBQUM7WUFDNUIsSUFBSSxDQUFDLGtCQUFrQixHQUFHLE1BQUEsR0FBRyxDQUFDLGtCQUFrQixtQ0FBSSxJQUFJLENBQUM7U0FDekQ7SUFDRixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksTUFBTSxDQUFDLElBQUksRUFBQyxnQkFBZ0I7UUFDbEMsT0FBTztJQUNSLENBQUM7SUFFRDs7O09BR0c7SUFFSSxJQUFJO1FBQ1YsT0FBTztJQUNSLENBQUM7SUFFRDs7O09BR0c7SUFFSSxNQUFNO1FBQ1osT0FBTztJQUNSLENBQUM7SUFFRDs7T0FFRztJQUNJLEtBQUs7UUFDWCxPQUFPO1lBQ04sUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRO1lBQ3ZCLFlBQVksRUFBRSxJQUFJLENBQUMsWUFBWTtZQUMvQixhQUFhLEVBQUUsSUFBSSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxZQUFZLEVBQUUsRUFBRSxDQUFDLFlBQVksQ0FBQyxLQUFLLEVBQUUsQ0FBQztZQUM3RSxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsa0JBQWtCLEVBQUUsSUFBSSxDQUFDLGtCQUFrQjtZQUMzQyxvQkFBb0IsRUFBRSxJQUFJLENBQUMsb0JBQW9CO1NBQy9DLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==